import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { api, getEventInfosByEventId } from 'ticketino-api-client';

import Loading from './Loading';

function EventSelect(props) {

    //----variables----

    //developement env dependent
    const baseUrl = process.env.REACT_APP_BASE_TICKETINO_URL;
    const baseProxyUrl = process.env.REACT_APP_PLUGIN_PROXY;

    //prop values
    const token = props.token;
    const eventGroupId = props.eventGroupId;
    const selectedLanguageCode = props.languageCode;
    const changeLanguage = props.changeLanguage;
    const changeEvent = props.changeEvent;
    const changePage = props.changePage;
    const selectedLanguage = props.languageISO;
    const showEventsAsList = props.showEventsAsList;

    const [selectedEventId, setSelectedEventId] = useState(0);
    const [eventGroup, setEventGroup] = useState({});
    const [loading, setLoading] = useState(true);
    const [resources, setResources] = useState("");

    useEffect(() => {
        axios.defaults.headers.common["Authorization"] = "Bearer " + token;
        api.defaults.headers.common['Authorization'] = "Bearer " + token;

        api.defaults.baseURL = baseUrl;

        if (eventGroupId > 0) {
            loadEventGroup(eventGroupId);
        }
    }, [eventGroupId]);

    useEffect(() => {
        requestResources(selectedLanguage);
    }, [selectedLanguage]);

    const requestResources = async (langauge) => {
        await axios
            .get(`${baseProxyUrl}/resources/${langauge}`)
            .then((res) => {
                setResources(res.data);
            })
            .catch((error) => console.error(error.response.data));
    };

    const loadEventGroup = async (id) => {
        try {
            let eventGroup = await getEventGroupByEventGroupId(id);
            let events = await getEventsThatAreInEventGroup(id);

            events = await Promise.all(events?.events?.map(async (event) => {
                const infos = await getEventInfosByEventId(event.id);
                return { ...event, info: infos?.eventInfos ?? [] }
            }))

            eventGroup.events = events;

            setEventGroup(eventGroup);
            setLoading(false)
        }
        catch (error) {
            console.error(error);
        }
    }

    const getEventGroupByEventGroupId = async (eventGroupId) => {
        try {
            const res = await axios.get(`${baseUrl}/EventGroup/${eventGroupId}`);
            return res.data;
        }
        catch (error) {
            console.error(error);
        }
    }

    const getEventsThatAreInEventGroup = async (eventGroupId) => {
        try {
            const res = await axios.get(`${baseUrl}/EventGroup/Events?eventGroupId=${eventGroupId}&languageCode=${selectedLanguage}`);
            return res.data;
        } catch (error) {
            console.error(error);
        }
    }

    const onSubmit = () => {
        changeEvent(selectedEventId);
        changePage(1);
    }

    //change the user selected langauge
    const updateLanguage = (language) => {
        requestResources(language);
        changeLanguage(language)
    }

    const languageSelectDiv = () => {
        return (
            <div className="container">
                <div className="row">
                    <div className="col-auto ms-auto">
                        <select
                            className="ticketinoSelect form-select"
                            aria-label=""
                            value={selectedLanguage}
                            onChange={(e) => {
                                updateLanguage(e.currentTarget.value);
                            }}
                        >
                            <option value={"en"} key={1} >{"en"}</option>
                            <option value={"de"} key={2} >{"de"}</option>
                            <option value={"fr"} key={3} >{"fr"}</option>
                            <option value={"it"} key={4} >{"it"}</option>
                        </select>
                    </div>
                </div>
            </div>
        )
    }
    const eventSelectClick = (eventId) => {
        setSelectedEventId(eventId);
        changeEvent(eventId);
        changePage(1);
    }

    const mapEvents = () => {
        let updatedEvents = [];

        if (eventGroup?.events && eventGroup?.events?.length > 0) {
            updatedEvents = [...eventGroup.events]
        }

        updatedEvents = updatedEvents.map((event) => {
            const eventInfo = event.info?.find(info => info.languageId === selectedLanguageCode) ?? event.info?.find(info => info.languageId === 0);
            return { ...event, info: eventInfo };
        })

        let eventClassName = "eventObjectDiv pt-2 pb-2";
        let eventParentClassName = "";
        let categoryClassName = "col-12 fs-6 fw-bold";

        if (showEventsAsList == "false") {
            eventClassName += " col-md-6 showAsBox p-2"
            eventParentClassName = "row";
        }

        return (
            <>
                <div className='eventObjectDiv row mb-2'>
                    <div className={categoryClassName}>
                        {resources.eventPage?.Kategorie}
                    </div>
                </div>
                <hr></hr>
                <div className={eventParentClassName}>
                    {updatedEvents?.map((event, index) => (
                        <div className={eventClassName} key={index}>
                            <div className='row mb-1'>
                                <div className='col-11 p-0 text-start'>
                                    <label className="ticketinoText fs-6 text-start">
                                        {event?.info?.name}
                                    </label>
                                    <div className="ticketinoText description text-secondary text-break text-start w-100 pe-3 mt-1">
                                        {event?.info?.shortDescription}
                                    </div>
                                    {!showEventsAsList && <div className="d-flex justify-content-start">
                                        <button
                                            className="button btn-orange btn-ticketino-large mb-4"
                                            onClick={() => { eventSelectClick(event.id) }}>
                                            {resources.eventPage?.buttonLabelContinue}
                                        </button>
                                    </div>}
                                </div>
                                {showEventsAsList &&
                                    <div className='col-1 p-0'>
                                        <div className="form-check text-center">
                                            <button
                                                className="button btn-orange btn-ticketino-large float-end mb-4"
                                                onClick={() => { eventSelectClick(event.id) }}>
                                                {resources.eventPage?.buttonLabelContinue}
                                            </button>
                                        </div>
                                    </div>}
                            </div>
                        </div>))}

                </div>
            </>
        )
    }

    return (
        <div className='page-container'>
            {languageSelectDiv()}
            {loading ? <Loading /> : <div className='container'>
                <div className="row">
                    <div className="col-12 mb-4">
                        <p className="ticketinoText text titleStyle text-start text-center fs-3 fw-semibold mb-2">{eventGroup?.name}</p>
                    </div>
                </div>
                {mapEvents()}
                {/*<button className="ticketinoButton btn button btn-light float-end"*/}
                {/*    disabled={!(selectedEventId > 0)}*/}
                {/*    onClick={onSubmit}>{resources.eventPage?.buttonLabelContinue}*/}
                {/*</button>*/}
            </div>}
        </div>
    )
}

export default EventSelect